/* Bloomeliya — carrousels du téléphone (Collection Capsule, « Au poignet, au sac… ») qui défilent tout seuls.
   S'arrête dès qu'on touche, reprend après quelques secondes. Rien sur ordinateur ni si l'animation est réduite. */
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const calme = window.matchMedia('(prefers-reduced-motion: reduce)');
  const PAUSE = 3500;
  const REPRISE = 6000;

  const lancer = (piste) => {
    if (piste.dataset.blmAuto) return;
    piste.dataset.blmAuto = '1';
    let minuteur = null;
    let visible = false;
    let attente = 0;

    const items = () => [...piste.children].filter((e) => e.offsetWidth > 0);
    const suivant = () => {
      if (!mobile.matches || calme.matches || !visible || Date.now() < attente) return;
      const liste = items();
      if (liste.length < 2) return;
      const fin = piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 8;
      if (fin) {
        piste.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      // positions de chaque élément, mesurées depuis le premier (même alignement que le premier)
      const base = liste[0].offsetLeft;
      const pos = liste.map((e) => e.offsetLeft - base);
      let ici = 0;
      pos.forEach((x, k) => { if (Math.abs(x - piste.scrollLeft) < Math.abs(pos[ici] - piste.scrollLeft)) ici = k; });
      const k = Math.min(ici + 1, liste.length - 1);
      piste.scrollTo({ left: pos[k], behavior: 'smooth' });
    };
    const arreter = () => { attente = Date.now() + REPRISE; };
    ['touchstart', 'pointerdown', 'wheel'].forEach((ev) => piste.addEventListener(ev, arreter, { passive: true }));

    new IntersectionObserver((e) => { visible = e[0].isIntersecting; }, { threshold: 0.4 }).observe(piste);
    minuteur = setInterval(suivant, PAUSE);
  };

  const chercher = () =>
    document.querySelectorAll('.collection .slider--mobile, .collection .slider--tablet, .blm-looks__grid').forEach(lancer);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', chercher);
  else chercher();
  document.addEventListener('shopify:section:load', chercher);
})();
